"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../hooks");
var store_1 = require("../../store");
var Button_1 = __importDefault(require("../Button"));
var FormatText_1 = __importDefault(require("../FormatText"));
var Icon_1 = __importDefault(require("../Icon"));
var LocaleSelector_1 = __importDefault(require("../LocaleSelector"));
var Header = antd_1.Layout.Header;
var AppHeader = function (props) {
    var logo = props.logo, title = props.title, onLogout = props.onLogout, extra = props.extra, favorite = props.favorite, setting = props.setting, help = props.help;
    var appConfig = store_1.useStore(function (state) { return state.ui.appConfig; });
    var hasMenu = store_1.useStore(function (state) { return state.ui.hasMenu; });
    var hasTitle = store_1.useStore(function (state) { return state.ui.hasTitle; });
    var hasHeader = store_1.useStore(function (state) { return state.ui; }).hasHeader;
    var removeAuthenticated = store_1.useActions(function (action) { return action.permission.removeAuthenticated; });
    var toggleMenuFullCollapse = store_1.useActions(function (state) { return state.ui.toggleMenuFullCollapse; });
    var _a = hooks_1.useFullscreen(document.documentElement), fullscreen = _a.fullscreen, toggleFullScreen = _a.toggleFullScreen;
    var fullscreenIcon = fullscreen ? 'arrows-circled_down_left_2' : 'arrows-circled_up_right_2';
    var onLogoff = function () {
        if (onLogout) {
            removeAuthenticated();
            onLogout();
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, hasHeader && (react_1.default.createElement(Header, { className: "ant-app-header" },
        react_1.default.createElement(antd_1.Row, { type: "flex", align: "middle" },
            react_1.default.createElement(antd_1.Col, { xs: 18, className: "ant-app-header-logo" },
                hasMenu && react_1.default.createElement(Icon_1.default, { className: "trigger", name: "games-xbox_menu", onClick: toggleMenuFullCollapse }),
                logo && react_1.default.createElement("img", { alt: "logo", src: logo }),
                react_1.default.createElement("span", { className: "ant-app-header-title" },
                    react_1.default.createElement(FormatText_1.default, { id: hasTitle ? title + " - " + hasTitle : title, uppercase: true }))),
            react_1.default.createElement(antd_1.Col, { xs: 6, className: "ant-app-header-actions" },
                extra,
                appConfig && appConfig.translations && react_1.default.createElement(LocaleSelector_1.default, null),
                favorite && react_1.default.createElement(Button_1.default, { icon: "ui-add_to_favorites", onClick: favorite }),
                setting && react_1.default.createElement(Button_1.default, { icon: "commons-settings", onClick: setting }),
                help && react_1.default.createElement(Button_1.default, { icon: "ui-help", onClick: help }),
                react_1.default.createElement(Button_1.default, { icon: fullscreenIcon, onClick: toggleFullScreen }),
                onLogout && react_1.default.createElement(Button_1.default, { icon: "ui-logout_rounded", onClick: onLogoff })))))));
};
exports.default = AppHeader;
